export * from './activities/activities.component';
export * from './components/course-heading/course-heading.component';
export * from './course-revision/course-revision.component';
export * from './curriculum/activity/assignment/assignment.component';
export * from './curriculum/activity/lecture/lecture.component';
export * from './curriculum/activity/quiz/quiz.component';
export * from './curriculum/curriculum.component';
export * from './curriculum/section/section.component';
export * from './detail/detail.component';
export * from './intended/intended.component';
export * from './pricing/pricing.component';
export * from './qa/qa.component';
export * from './reviews/reviews.component';
export * from './statistics/statistics.component';

import { CourseHeaderComponent } from './components/course-header/course-header.component';
import { CourseHeadingComponent } from './components/course-heading/course-heading.component';
import { CourseCurriculumComponent } from './curriculum/curriculum.component';
import { SectionComponent } from './curriculum/section/section.component';
import { CourseDetailsComponent } from './detail/detail.component';
import { CourseIntendedComponent } from './intended/intended.component';
import { CoursePricingComponent } from './pricing/pricing.component';
import { CourseReviewsComponent } from './reviews/reviews.component';
import { CourseStatisticsComponent } from './statistics/statistics.component';

// Section Itesm
import { ActivitiesComponent } from './activities/activities.component';
import { CourseRevisionComponent } from './course-revision/course-revision.component';
import { AssignmentComponent } from './curriculum/activity/assignment/assignment.component';
import { LectureComponent } from './curriculum/activity/lecture/lecture.component';
import { QuizComponent } from './curriculum/activity/quiz/quiz.component';
import { CourseQAComponent } from './qa/qa.component';

export const Components = [
  CourseStatisticsComponent,
  CourseReviewsComponent,
  CoursePricingComponent,
  CourseDetailsComponent,
  CourseHeadingComponent,
  CourseCurriculumComponent,
  SectionComponent,
  CourseIntendedComponent,
  CourseHeaderComponent,
  AssignmentComponent,
  QuizComponent,
  LectureComponent,
  CourseQAComponent,
  ActivitiesComponent,
  CourseRevisionComponent,
];
